import {Navbar, Nav, Form, Button} from "react-bootstrap"
//import { Link } from 'react-router-dom';
import {LinkContainer} from 'react-router-bootstrap'
import { useOktaAuth } from "@okta/okta-react";

const Header = () => {
    const { authState, oktaAuth } = useOktaAuth();

    if (authState?.isPending) {
      return <div>Loading...</div>;
    }

    const button = authState?.isAuthenticated ? (
      <Button
        variant="secondary"
        onClick={() => {
          oktaAuth.signOut("/");
        }}
      >
        Logout
      </Button>
    ) : (
      <Button
        variant="secondary"
        onClick={() => {
          oktaAuth.signInWithRedirect();
        }}
      >
        Login
      </Button>
    );

    return (
      <Navbar bg="light" expand="lg">
        <Navbar.Brand href="/" style={{marginLeft: "50px"}}>Brady SafeKey TestApp</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <LinkContainer to="/">
                <Nav.Link>Home</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/TestAPI">
                <Nav.Link>Test API</Nav.Link>
                </LinkContainer>
            <Nav.Link href="/swagger/index.html" target="_blank">Swagger UI</Nav.Link>
            <LinkContainer to="/redirect">
                <Nav.Link>Redirect Page</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/Instructions">
                <Nav.Link>Instructions</Nav.Link>
            </LinkContainer>
            {authState?.isAuthenticated && <LinkContainer to="/profile"><Nav.Link>Profile</Nav.Link></LinkContainer>}
            {authState?.isAuthenticated && <LinkContainer to="/log"><Nav.Link>Log</Nav.Link></LinkContainer>}
            {//<Nav.Link><Link className="customLink" to="/">Home</Link></Nav.Link>
            //<Nav.Link><Link className="customLink" to="/TestAPI">Test API Authentication</Link></Nav.Link>
            //<Nav.Link href="/swagger/index.html">Swagger UI</Nav.Link>
            //<Nav.Link><Link className="customLink" to="/Instructions">Home</Link></Nav.Link>
            //<Nav.Link><Link className="customLink" to="/profile">Home</Link></Nav.Link>
            }
          </Nav>
          <Form className="loginForm">{button}</Form>
        </Navbar.Collapse>
      </Navbar>
    );
  };
  export default Header;